import { render } from "./ExportarRegistros.vue?vue&type=template&id=39975c20"
import script from "./ExportarRegistros.vue?vue&type=script&lang=js"
export * from "./ExportarRegistros.vue?vue&type=script&lang=js"

import "./ExportarRegistros.vue?vue&type=style&index=0&id=39975c20&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__